// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Dashboard20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Dashboard20: FC<Dashboard20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M11 7V3h6v4h-6Zm-8 4V3h6v8H3Zm8 6V9h6v8h-6Zm-8 0v-4h6v4H3Zm1.5-7.5h3v-5h-3v5Zm8 6h3v-5h-3v5Zm0-9.98h3V4.5h-3v1.02Zm-8 9.98h3v-1h-3v1Z" />
        </svg>
    );
};

export default Dashboard20;
